<template>
    <el-dialog
        title="申请报团"
        :visible.sync="applyVisible"
        width="45%"
        :before-close="handleClose"
        center
        >
        <el-form ref="form" :model="form" :rules="rules" label-width="130px">
            <el-form-item label="选择招商活动：" prop="activity_id">
                <el-select v-model="form.activity_id" style="width: 100%;height: 25px;" placeholder="请选择招商活动">
                    <el-option
                    v-for="item in option"
                    :key="item.activity_id"
                    :label="item.activity_name"
                    :value="item.activity_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="申请理由：">
                <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" size="small" v-model="form.reason"></el-input>
                <div class="express">
                    可在【报团管理-我报的团】查看申请结果
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" style="backgroundColor:#F2F2F5;color:#45474D;borderColor:#FFFFFF" @click="handleClose">取 消</el-button>
            <el-button size="mini" style="backgroundColor:#fe2c55;color:#FFFFFF;borderColor:#FFFFFF" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>// @ts-nocheck
import { applyForList, applyActive } from '@/api/goods.js';
import Cookies from "js-cookie";
export default {
    props:{
        applyVisible:{
            type: Boolean,
            default: false
        },
        data:{
            type: Object,
            default: ()=>{}
        }
    },
    data(){
        return {
            option:[],
            form: {
                activity_id: '',
                reason: '',
                phone_number:'',
                service_ratio:'',
                products:[
                    {
                        product_id:'',
                        origin_activity_id:''
                    }
                ],
                institution_name: '雷兔',
                institution_id: '',
            },
            rules: {
                activity_id: [
                    { required: true, message: '请选择招商活动', trigger: 'blur' },
                ]
            }
        }
    },
    watch:{
        applyVisible(val){
            if(val){
                this.$nextTick(()=>{
                    this.$refs['form'].resetFields();
                    this.form.reason = '';
                    this.form.service_ratio = this.data.service_ratio;
                    this.form.institution_id = this.data.institution_id;
                    this.form.products[0].product_id = this.data.product_id;
                    this.form.products[0].origin_activity_id = this.data.origin_activity_id;
                    this.form.phone_number = JSON.parse(Cookies.get('userInfo')).phone;
                })
            }
        }
    },
    mounted(){
        this.applyForList();
    },
    methods:{
        // 请求可参与的二级团长活动查询接口;
        applyForList(){
            applyForList({
                inst_acti_name: '雷兔'
            }).then( res => {
                if(res.code == 800){
                    this.option = res.data;
                }
            })
        },
        // submit
        handleConfirm(){
            this.$refs['form'].validate((valid)=>{
                if(valid){
                    applyActive({
                        ...this.form
                    }).then( res => {
                        if(res.code == 800){
                            this.$message.success('申请成功')
                            this.$emit('successApply', 'success')
                        }
                    })
                }
            })
        },
        // 取消
        handleClose(){
            this.$emit('cancelApply','cancel')
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header{
    border-bottom: solid 1px #E6E7EB;
}
/deep/.el-input__inner{
    height: 40px;
}
/deep/.el-input-group--append{
    height: 40px;
}
.express{
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #8A8E99;
}
</style>